/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Card, CardContent, CircularProgress, Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { ReactComponent as DraftSvg } from "../../assets/img/draft.svg"
import { ReactComponent as FailedSvg } from "../../assets/img/failed.svg"
import { ReactComponent as FilesSvg } from "../../assets/img/files.svg"
import { ReactComponent as PlicksSvg } from "../../assets/img/plicks.svg"
import { ReactComponent as TotalSvg } from "../../assets/img/totalAmount.svg"
import { RootState } from "../../store"
import {
	FileStatisticsData,
	FileStatisticsState,
} from "../../store/actions/statistics"

const FileStatistics = () => {
	const { t } = useTranslation()
	const fileStatisticsState: FileStatisticsState = useSelector(
		(state: RootState) => state.statistics.file
	)

	const CardTotalFile = () => {
		return (
			<Grid container>
				<Grid item>
					<FilesSvg width={"90px"} height={"90px"} />
				</Grid>
				<Grid item>
					<Grid
						container
						flexDirection={"column"}
						sx={{
							justifyContent: "space-around",
							height: "100%",
							alignItems: "center",
						}}
					>
						<Grid item sx={{ fontSize: "24px" }}>
							{statisticsData && statisticsData?.totalFiles}
						</Grid>
						<Grid
							item
							sx={{
								fontSize: "14px",
								fontWeight: "bold",
								marginBottom: "16px",
							}}
						>
							{t("card.file.total", { ns: "dashboard" })}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		)
	}

	const CardFailedFile = () => {
		return (
			<Grid container>
				<Grid item>
					<FailedSvg width={"90px"} height={"90px"} />
				</Grid>
				<Grid item>
					<Grid
						container
						flexDirection={"column"}
						sx={{
							justifyContent: "space-around",
							height: "100%",
							alignItems: "center",
						}}
					>
						<Grid item sx={{ fontSize: "24px" }}>
							{statisticsData && statisticsData?.totalErrors}
						</Grid>
						<Grid
							item
							sx={{
								fontSize: "14px",
								fontWeight: "bold",
								marginBottom: "16px",
							}}
						>
							{t("card.file.error", { ns: "dashboard" })}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		)
	}

	const CardTotalAmountFile = () => {
		return (
			<Grid container>
				<Grid item>
					<TotalSvg width={"90px"} height={"90px"} />
				</Grid>
				<Grid item>
					<Grid
						container
						flexDirection={"column"}
						sx={{
							justifyContent: "space-around",
							height: "100%",
							alignItems: "center",
						}}
					>
						<Grid item sx={{ fontSize: "24px" }}>
							€
							{statisticsData &&
								Math.round(statisticsData?.totalAmount * 100) / 100}
						</Grid>
						<Grid
							item
							sx={{
								fontSize: "14px",
								fontWeight: "bold",
								marginBottom: "16px",
							}}
						>
							{t("card.file.plick", { ns: "dashboard" })}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		)
	}

	const CardDraftFile = () => {
		return (
			<Grid container>
				<Grid item>
					<DraftSvg width={"90px"} height={"90px"} />
				</Grid>
				<Grid item>
					<Grid
						container
						flexDirection={"column"}
						sx={{
							justifyContent: "space-around",
							height: "100%",
							alignItems: "center",
						}}
					>
						<Grid item sx={{ fontSize: "24px" }}>
							{statisticsData && statisticsData?.totalDraft}
						</Grid>
						<Grid
							item
							sx={{
								fontSize: "14px",
								fontWeight: "bold",
								marginBottom: "16px",
							}}
						>
							{t("card.file.draft", { ns: "dashboard" })}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		)
	}

	const CardPlicks = () => {
		return (
			<Grid container>
				<Grid item>
					<PlicksSvg width={"90px"} height={"90px"} />
				</Grid>
				<Grid item>
					<Grid
						container
						flexDirection={"column"}
						sx={{
							justifyContent: "space-around",
							height: "100%",
							alignItems: "center",
						}}
					>
						<Grid item sx={{ fontSize: "24px" }}>
							{statisticsData && statisticsData?.totalPlicks}
						</Grid>
						<Grid
							item
							sx={{
								fontSize: "14px",
								fontWeight: "bold",
								marginBottom: "16px",
							}}
						>
							{t("card.file.plickCreated", { ns: "dashboard" })}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		)
	}

	const statisticsData = fileStatisticsState?.data?.reduce(
		(
			accumulator: {
				totalFiles: number
				totalErrors: number
				totalDraft: number
				totalPlicks: number
				totalAmount: number
			},
			fileStat: FileStatisticsData
		) => {
			return {
				totalFiles: (accumulator.totalFiles ?? 0) + (fileStat?.totalFiles ?? 0),
				totalErrors: (accumulator.totalErrors ?? 0) + (fileStat?.errors ?? 0),
				totalDraft: (accumulator.totalDraft ?? 0) + (fileStat?.drafts ?? 0),
				totalPlicks:
					(accumulator.totalPlicks ?? 0) + (fileStat?.plicksCount ?? 0),
				totalAmount:
					(accumulator.totalAmount ?? 0) + (fileStat?.totalAmount ?? 0),
			}
		},
		{
			totalFiles: 0,
			totalErrors: 0,
			totalDraft: 0,
			totalPlicks: 0,
			totalAmount: 0,
		}
	)

	/*
        <Grid container>
            <Grid item>
                <Card sx={{ borderRadius: '.25rem', boxShadow: '0 0 .875rem 0 rgba(52, 58, 64, .05)' }}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="Utenti">
                                <PeopleAltIcon />
                            </Avatar>
                        }
                        title="Distinte"
                        subheader=""
                    />
                    <CardContent>
                        <div>
                            <h1>{statisticsData && statisticsData?.totalFiles} Totale distinte</h1>
                        </div>
                        <div>{statisticsData && statisticsData?.totalErrors} Distinte in errore</div>
                        <div>{statisticsData && statisticsData?.totalDraft} Distinte in draft</div>
                        <div>{statisticsData && statisticsData?.totalPlicks} Plick creati</div>
                        <div>{statisticsData && statisticsData?.totalAmount}€ Totale</div>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
        */
	return fileStatisticsState.isLoading ? (
		<Grid
			container
			flexDirection="column"
			sx={{ width: "100%", alignItems: "center" }}
		>
			<Grid item>
				<CircularProgress color="secondary" />
			</Grid>
			<Grid item>
				{t("loading.title", { ns: "dashboard" })}
				<br /> {t("loading.subtitle2", { ns: "dashboard" })}
			</Grid>
		</Grid>
	) : (
		<Grid container gap={"16px"} sx={{ marginTop: "16px" }}>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardTotalFile />
					</CardContent>
				</Card>
			</Grid>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardFailedFile />
					</CardContent>
				</Card>
			</Grid>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardDraftFile />
					</CardContent>
				</Card>
			</Grid>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardPlicks />
					</CardContent>
				</Card>
			</Grid>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardTotalAmountFile />
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	)
}

export default FileStatistics
